/**
 * Script handle show, hide read-more-inpage
 */

(function ($) {
    'use strict';

    function initReadmore() {
        var entry, button;

        entry = $('.entry-content');
        button = $('.button-read-more');

        if (entry.length <= 0 || button.length <= 0)
            return false;

        button.on('click', function () {
            button.parent('p').hide();
            entry.find('.text-expand').show();
        });
    }

    initReadmore();
})(jQuery);